import type { FC } from 'react';
import { formatSectorWithVisibility } from '../../seatSelection/utils/formatSeatVisibility';

type SeatTooltipProps = {
  tooltip: {
    x: number;
    y: number;
    price: number;
    seatInfo: string;
    sectorName: string;
    visibility?: string | null;
  } | null;
  hidden?: boolean;
};

const SeatTooltip: FC<SeatTooltipProps> = ({ tooltip, hidden = false }) => {
  if (!tooltip || hidden) return null;

  return (
    <div
      className="pointer-events-none absolute z-[100] max-w-[320px] whitespace-normal break-words rounded-lg border border-border-strong bg-surface-card px-3 py-2 text-center text-sm font-medium leading-snug text-text-primary shadow-[var(--shadow-md)] backdrop-blur-sm"
      style={{
        top: tooltip.y,
        left: tooltip.x,
        transform: 'translate(-50%, -110%)',
      }}
    >
      {tooltip.seatInfo ? <div>{tooltip.seatInfo}</div> : null}
      {tooltip.sectorName ? (
        <div className="mb-1 text-text-muted">
          {formatSectorWithVisibility(tooltip.sectorName, tooltip.visibility)}
        </div>
      ) : null}
      <div className="text-text-muted">{tooltip.price} ₽</div>
    </div>
  );
};

export default SeatTooltip;
